import React from 'react';
import { View, StyleSheet, Platform, Text, TouchableOpacity } from 'react-native';
import { Stack, useLocalSearchParams } from 'expo-router';
import theme from '../../config/theme';
import { FieldOrderingLogger } from '../../utils/logger';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useRouter } from 'expo-router';

// Importa variante web (já implementada). Para mobile exibiremos placeholder até implementarmos.
import FieldOrderingBoardWeb from '../../components/fieldOrdering/FieldOrderingBoard.web';

export default function FieldOrderingScreen() {
  const params = useLocalSearchParams<{ templateId?: string }>();
  const templateId = params.templateId as string | undefined;
  const router = useRouter();

  FieldOrderingLogger.Main.info('[FIELD-ORDERING.GENERIC] Render com templateId=' + templateId + ' platform=' + Platform.OS);

  if (Platform.OS !== 'web') {
    return (
      <View style={styles.container}>
        <Stack.Screen options={{ headerShown: false }} />
        <View style={styles.header}>
          <TouchableOpacity style={styles.backButton} onPress={() => router.back()}>
            <MaterialCommunityIcons name="arrow-left" size={24} color={theme.colors.text.inverse} />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>Ordenar Campos</Text>
          <View style={{ width: 40 }} />
        </View>
        <Text style={styles.placeholderText}>Funcionalidade de ordenação disponível apenas na web (em breve no mobile).</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Stack.Screen options={{ title: 'Ordenar Campos', headerShown: true }} />
      <FieldOrderingBoardWeb templateId={templateId} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background.secondary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    backgroundColor: theme.colors.primary.default,
    padding: theme.spacing.lg,
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    flex: 1,
    fontSize: theme.fontSizes.xl,
    color: theme.colors.text.inverse,
    fontWeight: theme.fontWeights.bold as any,
    textAlign: 'center',
  },
  placeholderText: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.text.secondary,
    textAlign: 'center',
    padding: theme.spacing.md,
  },
}); 